import React from 'react';

const Wrapper: React.FC<{ className?: string }> = ({ className, children }) => (
  <div className={`max-w-screen-lg mx-auto px-4 pb-4 ${className}`}>{children}</div>
);

export default Wrapper;
